import Geohash from "latlon-geohash";
export function geohashForLocation(lat:number, lng:number) {
  return Geohash.encode(lat, lng, 9);
}
export function distanceMiles(lat1:number, lon1:number, lat2:number, lon2:number) {
  if (lat1==null || lon1==null || lat2==null || lon2==null) return Infinity;
  const toRad = (d:number)=>d*Math.PI/180;
  const R = 3958.8;
  const dLat = toRad(lat2-lat1), dLon = toRad(lon2-lon1);
  const a = Math.sin(dLat/2)**2 + Math.cos(toRad(lat1))*Math.cos(toRad(lat2))*Math.sin(dLon/2)**2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
}
export function naiveGeohashWindow(lat:number, lng:number) {
  const gh = geohashForLocation(lat, lng);
  return { lower: gh.slice(0,5) + "0", upper: gh.slice(0,5) + "z" };
}

